<template>
  <div style="height:100%;">
    <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
      <zj-layout-header style="padding:0.8rem 0.8rem 0rem 0.8rem;">
        <div class="zj-button-bar" v-if="IsEdit">
          <el-button size="mini" @click="onAdd">添 加</el-button>
        </div>
      </zj-layout-header>
      <zj-layout-main style="padding:0.8rem 0px 0px 0px;">
        <el-table :data="tableData" border style="width: 100%" height="100%">
          <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
          <el-table-column prop="PersonName" label="姓名" align="center"></el-table-column>
          <el-table-column prop="Sex" label="性别" :formatter="ConvertSex" align="center"></el-table-column>
          <el-table-column prop="TitleName" label="职级" align="center"></el-table-column>
          <el-table-column prop="Age" label="年龄" align="center"></el-table-column>
          <el-table-column prop="Birthday" label="出生日期" :formatter="formatDate" width="180" align="center"></el-table-column>
          <el-table-column prop="PhoneNum" label="联系电话" align="center"></el-table-column>
          <el-table-column label="操作" width="130" align="center">
            <template slot-scope="scope">
              <el-button
                @click="handleClick(scope.$index,scope.row)"
                type="text"
                size="small"
              >查看</el-button>
              <el-button v-if="IsEdit"
                @click="deleteClick(scope.$index,scope.row)"
                type="text"
                size="small"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </zj-layout-main>
    </zj-layout-container>
    <el-dialog v-dialogDrag :visible.sync="dialogInfoVisible" title="通讯录详情">
      <Addressbookinfo @onClose="onClose" opentype="true" :isHeadVisiable="false" :playerInfo="playerInfo" style="height:64rem;"></Addressbookinfo>
    </el-dialog>
    <el-dialog v-dialogDrag :visible.sync="dialogTableVisible" title="选择队员" width="100rem" @opened="onopened">
      <zj-layout-container style="max-height: 60rem;">
        <zj-layout-main style="padding:0;">
          <el-table
            ref="multipleTable"
            :data="DialogtableData"
            :append-to-body="true"
            @selection-change="handleSelectionChange"
            border
            style="width:100%"
            height="100%"
          >
            <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
            <el-table-column prop="PersonName" label="姓名" align="center"></el-table-column>
            <el-table-column prop="Sex" label="性别" :formatter="ConvertSex" align="center"></el-table-column>
            <el-table-column prop="TitleName" label="职级" align="center"></el-table-column>
            <el-table-column prop="Age" label="年龄" align="center"></el-table-column>
            <el-table-column prop="Birthday" label="出生日期" :formatter="formatDate" width="180" align="center"></el-table-column>
            <el-table-column prop="PhoneNum" label="联系电话" align="center"></el-table-column>
            <el-table-column type="selection" width="55" align="center"></el-table-column>
          </el-table>
        </zj-layout-main>
        <zj-layout-footer style="text-align: center;margin-bottom:-1rem;padding-top:2rem;">
          <el-button @click="onBack()">取消</el-button>
          <el-button @click="onOk()">确定</el-button>
        </zj-layout-footer>
      </zj-layout-container>
    </el-dialog>
  </div>
</template>

<script>
import MyApis from "../../../apis";
import Addressbookinfo from "./Addressbookinfo";
export default {
  name: "ZjResourcesTeamPlayerlist",
  controller: "EmergencyResource",
  action: "ResourcesTeamPlayerlist",
  props: {
    query: {
      type: String,
      obj: String
    }
  },
  data() {
    return {
      loading: false,
      loadingText: '加载中...',
      tableData: [],
      selectData: null,
      dialogInfoVisible: false,
      playerInfo: {},
      dialogTableVisible: false,
      DialogtableData: [],
      multipleSelection: [],
      IsEdit: false
    };
  },
  components: {
    Addressbookinfo
  },
  mounted: function() {
    this.searchDiaTabData();
    this.IsEdit = this.query.type == "edit" ? true : false;
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox"
      });
    },
    searchDiaTabData() {
      let RecordId = this.query.obj;
      let searchInfo = {
        PageSize: 2000,
        PageIndex: 1,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0
      };
      this.loading = true;
      this.loadingText = '加载中...';
      new MyApis.AddressbookApi()
        .GetPageContentByConditions(searchInfo)
        .then(r => {
          r = r.data.Data;
          var data = r.PageContents;
          var tabdata = [];
          var tabDia = [];
          for (var i = 0; i < data.length; i++) {
            var item = data[i];
            if (
              item.ResourceId == "" ||
              item.ResourceId == null ||
              item.ResourceId == RecordId
            ) {
              tabDia.push(item);
            }
            if (item.ResourceId == RecordId) {
              tabdata.push(item);
            }
          }
          this.DialogtableData = tabDia;
          this.tableData=tabdata;
          this.loading = false;
        })
        .catch(e => {
          console.error(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          this.loading = false;
        });
    },
    //查看详细
    handleClick(index, row) {
      this.playerInfo = row;
      this.dialogInfoVisible = true;
    },
    //添加
    onAdd() {
      this.multipleSelection = this.tableData;
      this.dialogTableVisible = true;
    },
    onopened() {
      this.toggleSelection(this.multipleSelection);
    },
    toggleSelection(rows) {
      this.$refs.multipleTable.clearSelection();
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      }
    },
    UpdatePlayerInfo(data) {
      this.loading = true;
      this.loadingText = '更新中...';
      new MyApis.AddressbookApi()
        .UpdateItemList(data)
        .then(r => {
          this.loading = false;
          r = r.data.Data;
          if (r) {
            this.tableData = this.multipleSelection;
          }
        })
        .catch(e => {
          console.error(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          this.loading = false;
        });
    },
    onOk() {
      this.UpdatePlayerInfo(this.multipleSelection);
      this.dialogTableVisible = false;
    },
    onClose() {
      this.dialogInfoVisible = false;
    },
    onBack() {
      this.dialogTableVisible = false;
    },
    handleSelectionChange(val) {
      let RecordId = this.query.obj;
      if (val) {
        for (var i = 0; i < val.length; i++) {
          var item = val[i];
          item.ResourceId = RecordId;
        }
      }
      this.multipleSelection = val;
      //console.log(this.multipleSelection);
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("确定要删除该行吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
      .then(()=>{
        row.ResourceId = null;
        this.loading = true;
        this.loadingText = '删除中...';
        new MyApis.AddressbookApi()
          .UpdateItem(row)
          .then(r => {
            this.loading = false;
            r = r.data.Data;
            if (r) {
              this.searchDiaTabData();
            }
          })
          .catch(e => {
            console.error(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            this.loading = false;
          });
      });
      
    },
    ConvertSex(row, column) {
      let data = row[column.property];
      if (data == null) {
        return null;
      }
      if (data == "1") {
        return "男";
      }
      if (data == "2") {
        return "女";
      }
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    }
  }
};
</script>